/**
 * @file
 * Pluxee accordtion tabs script.
 */

(function (Drupal, $) {
    'use strict';
    Drupal.behaviors.pluxeeAccordionTabs = {
        attach: function (context, settings) {
            const $accordionTabs = $(context).find('.coh-accordion-tabs');

            $(once('accordion-tabs-loaded', $accordionTabs)).each(function (indexTabs) {
                const $this = $(this);
                const $accordionTabsContainer = $this.parents('div[class*="coh-ce-cpt_plx_tabs"]');
                const accordionTabsTitle = $accordionTabsContainer.find('h2[class*="coh-ce-cpt_heading_0"]').text().trim();
                const $accordionTabsNav = $this.find('.coh-accordion-tabs-nav');
                const $accordionTabItem = $accordionTabsNav.find('li');

                $accordionTabsNav
                    .attr('role', 'tablist')
                    .attr('aria-label', accordionTabsTitle);

                $(once('accordion-tabitem-loaded', $accordionTabItem)).each(function (index) {
                    const $item = $(this);
                    const $itemLink = $item.find('a');
                    const itemTitle = $itemLink.text().toLowerCase().replace(/\s+/g, '_');

                    $item.attr('role', 'presentation');
                    $itemLink
                        .attr('role', 'tab')
                        .attr('aria-controls', itemTitle)
                        .attr('tabindex', index === 0 ? '0' : '-1')
                        .attr('aria-selected', index === 0 ? 'true' : 'false');
                });

                const $accordionTabsContent = $accordionTabsContainer.find('.coh-accordion-tabs-content');

                $(once('accordion-tabscontent-loaded', $accordionTabsContent)).each(function (index) {
                    const $tabContent = $(this);
                    const $tabContentTitle = $tabContent.prev('.coh-accordion-title').find('a');
                    const tabContentTitleValue = $tabContentTitle.text().toLowerCase().replace(/\s+/g, '_');

                    $tabContentTitle.attr('role', 'button');
                    $tabContent
                        .attr('id', tabContentTitleValue)
                        .attr('role', 'tabpanel')
                        .attr('tabindex', '0');
                });

                const $accordionTabLink = $accordionTabItem.find('a');

                const updateTab = ($tab) => {
                    $accordionTabLink
                        .attr('tabindex', '-1')
                        .attr('aria-selected', 'false');
                    $tab
                        .attr('tabindex', '0')
                        .attr('aria-selected', 'true')
                        .focus();
                };

                $accordionTabLink.on('click', function (e) {
                    updateTab($(this));
                });

                $accordionTabLink.on('keydown', function (e) {
                    const key = e.key;
                    const $current = $(this);
                    const $currentItem = $current.closest('li');

                    if (key === 'Home') {
                        e.preventDefault();

                        $accordionTabLink.first().click();

                        return;
                    }

                    if (key === 'End') {
                        e.preventDefault();

                        $accordionTabLink.last().click();

                        return;
                    }

                    let $targetItem;

                    if (key === 'ArrowRight') {
                        $targetItem = $currentItem.next('li');
                    } else if (key === 'ArrowLeft') {
                        $targetItem = $currentItem.prev('li');
                    } else {
                        return;
                    }

                    if ($targetItem && $targetItem.length) {
                        e.preventDefault();

                        $targetItem.find('a').click();
                    }
                });
            });
        }
    };
})(Drupal, jQuery);